// Logged-in app page: post captions (routes/Captions.tsx). Keep keys in sync with pl/appCaptions.ts.
// Paczka 34: the counter is now "{n}/150" with the hashtag count beside it, the rule moved into
// the field's placeholder, and every state speaks in one sentence.
export const appCaptions = {
  head: {
    title: 'Captions',
  },
  intro: {
    body: 'Text for your posts.',
  },
  // THE "VARIABLES" DIALOG (rule 33, round B-R3). Only the variables the parser
  // substitutes today (`lib/textTemplates.ts`). The example is the RESULT of the
  // substitution, not the variable spelled again: the row shows what a viewer
  // will read. The "Random" group waits for `{random_emoji}` — a heading with no
  // rows does not render.
  variables: {
    label: 'Variables',
    intro: 'You fill in the values when you plan the pack for publishing.',
    fixed: 'Fixed',
    random: 'Random',
    artist: 'artist name',
    artistExample: 'Nocna Zmiana, a new track',
    title: 'track title',
    titleExample: 'Mokry asfalt is out',
    nick: 'account the post goes to',
    nickExample: '@domi.music',
    timestamp: 'moment in the track',
    timestampExample: 'the bass drops at 0:31',
    // Screen-reader names; the component substitutes {variable}.
    insert: 'Insert {variable}',
    copy: 'Copy {variable}',
    copied: 'Copied',
    copyFailed: 'Could not copy.',
    close: 'Close',
  },
  list: {
    heading: 'Packs',
    collection_one: 'pack',
    collection_few: 'packs',
    collection_many: 'packs',
    captions_one: 'caption',
    captions_few: 'captions',
    captions_many: 'captions',
    newCollection: 'New pack',
  },
  form: {
    name: 'Name',
    namePlaceholder: 'e.g. Release captions',
    create: 'Create',
    cancel: 'Cancel',
  },
  rules: {
    line: 'Up to 150 characters · at most 3 hashtags · no promises about what happens after posting',
    length: 'Up to 150 characters.',
    hashtags: 'At most 3 hashtags.',
  },
  state: {
    loadError: 'Could not load the packs.',
    emptyTitle: 'No caption packs',
    emptyBody: 'Start from a ready EDIMI pack or create your own - captions are offered when you publish an edit.',
  },
  coll: {
    own: 'yours',
    more: 'More actions: {name}',
    expand: 'Expand pack {name}',
    collapse: 'Collapse pack {name}',
    deleteCollectionTitle: 'Delete pack',
    deleteAsk: 'Delete this pack?',
    deleteRow: 'Captions',
    emptyItems: 'No captions',
    deleteItemTitle: 'Delete caption',
    deleteItemLabel: 'Delete caption “{text}”',
    deleteItemAsk: 'Delete the caption “{text}”?',
    rowMenu: 'Caption',
    addHeading: 'Add a caption',
    oneEach: 'One caption per line',
    add: 'Add',
    addN: 'Add {count} captions',
    addN_one: 'Add {count} caption',
    addN_few: 'Add {count} captions',
    addN_many: 'Add {count} captions',
    pasteCount: '{count} captions to add',
    pasteCount_one: '{count} caption to add',
    pasteCount_few: '{count} captions to add',
    pasteCount_many: '{count} captions to add',
  },
  system: {
    heading: 'EDIMI packs',
    countAll: '{n} · ready to use',
    readOnly: 'read-only',
    copyToMine: 'Copy to mine',
    copyDone: 'Copied to my packs.',
    andMore: '…and {count} more',
  },
  library: {
    mine: 'Mine',
    all: 'All packs',
    edimi: 'EDIMI',
    newPack: 'New pack',
    save: 'Save',
    rename: 'Rename',
    openPack: 'Open {name}',
    selectPack: 'Select the “{name}” pack',
    deletePack: 'Delete pack',
    deletePacksAsk: 'Delete {count} packs?',
    deletePacksAsk_one: 'Delete this pack?',
    deletePacksAsk_few: 'Delete {count} packs?',
    deletePacksAsk_many: 'Delete {count} packs?',
    deletePacksDo: 'Delete {count} packs',
    deletePacksDo_one: 'Delete pack',
    deletePacksDo_few: 'Delete {count} packs',
    deletePacksDo_many: 'Delete {count} packs',
    selected: 'selected',
    // Czasownik, nie samo słowo zbioru: obok stoi pigułka zakresu „Wszystkie”,
    // a te dwa przyciski robią rzeczy przeciwne (przegląd D).
    selectAll: 'Select all',
    selectNone: 'None',
    emptyAll: 'No caption packs',
    emptyAllBody: 'Create your own pack or open EDIMI to get started.',
    emptyEdimi: 'No EDIMI packs',
    emptyEdimiBody: 'EDIMI packs will appear here when they are available in this language.',
    choosePackPrompt: 'Choose a pack',
    choosePackPromptBody: 'Captions from the selected pack will appear here.',
    actionFailed: 'Could not complete the action.',
    back: 'Captions',
    selectItem: 'Select caption “{text}”',
    moveItems: 'Move to another pack',
    copyItems: 'Copy to another pack',
    deleteItemsAsk: 'Delete {count} captions?',
    deleteItemsAsk_one: 'Delete this caption?',
    deleteItemsAsk_few: 'Delete {count} captions?',
    deleteItemsAsk_many: 'Delete {count} captions?',
    deleteItemsDo: 'Delete {count} captions',
    deleteItemsDo_one: 'Delete caption',
    deleteItemsDo_few: 'Delete {count} captions',
    deleteItemsDo_many: 'Delete {count} captions',
    addRules: 'One caption per line · up to 150 characters · at most 3 hashtags · use {@nick} as a variable',
    targetPack: 'Target pack',
    choosePack: 'Choose a pack',
    confirmMove: 'Move {count} captions',
    confirmMove_one: 'Move {count} caption',
    confirmMove_few: 'Move {count} captions',
    confirmMove_many: 'Move {count} captions',
    confirmCopy: 'Copy {count} captions',
    confirmCopy_one: 'Copy {count} caption',
    confirmCopy_few: 'Copy {count} captions',
    confirmCopy_many: 'Copy {count} captions',
    noTarget: 'You have no other pack of your own.',
    noTargetBody: 'Create another empty caption pack first.',
    errorConflict: 'The target pack has different content in the same place.',
    errorChanged: 'The pack changed during the action.',
    errorMissing: 'A caption or the pack no longer exists.',
    errorSame: 'Choose a different target pack.',
    errorGeneric: 'Could not complete the action.',
    invalid: 'Fix the caption before adding it',
    retry: 'Try again',
    newPackFailed: 'Could not create the pack.',
    // Paczka 34: the shelf's quiet actions, the selection bar, the plan pill in the delete window.
    select: 'Select',
    selectedCount: 'Selected: {count}',
    deleteCount: 'Delete ({count})',
    moveShort: 'Move',
    copyShort: 'Copy',
    loadFailed: 'Could not load your caption packs.',
    inPlan: 'in a publishing plan',
    toastAdded: 'Added {count} captions.',
    toastAdded_one: 'Added {count} caption.',
    toastAdded_few: 'Added {count} captions.',
    toastAdded_many: 'Added {count} captions.',
    toastMoved: 'Moved {count} captions to “{name}”.',
    toastMoved_one: 'Moved {count} caption to “{name}”.',
    toastMoved_few: 'Moved {count} captions to “{name}”.',
    toastMoved_many: 'Moved {count} captions to “{name}”.',
    toastCopied: 'Copied {count} captions to “{name}”.',
    toastCopied_one: 'Copied {count} caption to “{name}”.',
    toastCopied_few: 'Copied {count} captions to “{name}”.',
    toastCopied_many: 'Copied {count} captions to “{name}”.',
    toastPackDeleted: 'Pack deleted.',
    toastPackDeleteFailed: 'Could not delete the pack.',
  },
  item: {
    copy: 'Copy caption',
    copied: 'Caption copied.',
    copyFailed: 'Could not copy the caption.',
    count: '{chars}/{limit}',
    chars_one: '{count} character',
    chars_few: '{count} characters',
    chars_many: '{count} characters',
    hashtags_one: '{count} hashtag',
    hashtags_few: '{count} hashtags',
    hashtags_many: '{count} hashtags',
    more: 'Caption {i} of {n}',
  },
  field: {
    label: 'New caption',
    placeholder: 'post text',
  },
}
